import { apiClient, makeServicePlugin, BaseModel } from "@/store/api";

class Submission extends BaseModel {
    constructor(data, options) {
        super(data, options);
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = "Submission";

    // Define default properties here
    static instanceDefaults() {
        return {
            id: null,
            manager_id: null,
            form_id: null,
            assigned: null,
            name: '',
            status: '',
            schedule: {},
            sections: [],
            verified: false,
            verified_by: null,
            verifiedAt: null,
            transferred_by: null,
            createdAt: ''
        };
    }
}
const servicePath = "submissions";
const servicePlugin = makeServicePlugin({
    Model: Submission,
    service: apiClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
apiClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin;
